// Shared helpers for the lab dashboards (LLM Lab, TTS Lab).

export type TimeRange = "24h" | "7d" | "30d";

export const TIME_RANGE_OPTIONS: { label: string; value: TimeRange }[] = [
  { label: "24h", value: "24h" },
  { label: "7d", value: "7d" },
  { label: "30d", value: "30d" },
];

const RANGE_MS: Record<TimeRange, number> = {
  "24h": 24 * 60 * 60 * 1000,
  "7d": 7 * 24 * 60 * 60 * 1000,
  "30d": 30 * 24 * 60 * 60 * 1000,
};

export function getDateRange(range: TimeRange): { startDate: string; endDate: string } {
  const now = new Date();
  return {
    endDate: now.toISOString(),
    startDate: new Date(now.getTime() - RANGE_MS[range]).toISOString(),
  };
}

export function formatMs(value: number | null): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  if (value >= 1000) return `${(value / 1000).toFixed(2)}s`;
  return `${Math.round(value)}ms`;
}

export function formatCount(value: number | null): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
  return Math.round(value).toString();
}
